// extracted by mini-css-extract-plugin
module.exports = {"body":"TableListBody_body__1b0mt"};